export const HOME = "/";
export const NEWS = "news";
export const DETAIL = "/news/detail/:id";
export const ADVERT = "advert";
export const RATE = "rate";
export const CONTACTS = "contacts";
export const CATALOG = "catalog/:type";
export const NOTFOUND = "*";
export const LOGIN = "login";
export const REGISTRATION = "registration";
